import React from 'react';
import DefaultLayout from '@presentation/layouts/DefaultLayout';
import Puzzle from '@presentation/pages/Puzzle';
import type { ContentItemWithCollectionsModel } from '@domain/models/ContentItemWithCollectionsModel';

const makePuzzle = (puzzle: ContentItemWithCollectionsModel) => (
	<DefaultLayout>
		<Puzzle puzzle={puzzle} />
	</DefaultLayout>
);

export default makePuzzle;
